import chunk from 'lodash/chunk';

import { ServerListResponse } from '@lumapps/base-api/types';

import { MAX_ARTICLE_IDS_PER_CALL } from '../constants';
import { GetArticlesParams } from '../types';
import { getArticles } from './getArticles';
import { Article } from './types';

/**
 * Get articles by ids, chunking the calls so that each request stays under the
 * backend limit of ids accepted per `articles` GET call.
 */
export async function getArticlesByIds(params: GetArticlesParams): Promise<ServerListResponse<Article>> {
    const { ids, ...restParams } = params;

    if (!ids?.length) {
        return getArticles(params);
    }

    const responses = await Promise.all(
        chunk(ids, MAX_ARTICLE_IDS_PER_CALL).map((idsChunk) => getArticles({ ...restParams, ids: idsChunk })),
    );

    return {
        items: responses.flatMap((response) => response.items),
        more: false,
        cursor: '',
    };
}
